var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upsi-dialog-banner",class:`upsi-dialog-banner--${_vm.tone}`,attrs:{"data-testid":"upsi-dialog-banner","role":"status"}},[_c('v-icon',{staticClass:"upsi-dialog-banner__icon",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.icon))]),_c('p',{staticClass:"upsi-dialog-banner__message"},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }